module.exports = __webpack_public_path__ + "static/media/iedagen.7ffb5c92.png";